import { toast } from 'react-toastify';

export const handleCallApi = async (method, url, bodyData, success, error, toastOptions = {}) => {

  if (typeof bodyData !== 'string') {
    bodyData = JSON.stringify(bodyData);
  }

  try {
    let requestOptions = {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      ...(bodyData && bodyData !== 'null' ? { body: bodyData } : {}),
    };
    let response = await fetch(url, requestOptions);
    let dataResponse = await response.json();
    if (response.ok) {
      if (success !== '') {
        toast.success(success, toastOptions);
      }
      return dataResponse;
    } else {
      if (error !== '') {
        toast.error(error, toastOptions);
      }
    }
  } catch (error) {
    ;
    // throw new Error(error.message || "Something went wrong");
  }
};

// Fetches every page of a skip/take list endpoint, so lists never silently stop at a hard-coded take.
// Returns { count, results } like a single page, or undefined if any page fails.
export const getAllFromApi = async (url, pageSize = 2000) => {
  const results = [];
  const seenIds = new Set();
  const separator = url.includes('?') ? '&' : '?';
  for (let skip = 0; ; skip += pageSize) {
    const page = await getDatafromApi(`${url}${separator}take=${pageSize}&skip=${skip}`);
    if (!page || !Array.isArray(page.results)) {
      return undefined;
    }
    const fresh = page.results.filter((item) => !seenIds.has(item.id));
    fresh.forEach((item) => seenIds.add(item.id));
    results.push(...fresh);
    // Short page = last page; no new ids = endpoint ignores skip (would loop forever)
    if (page.results.length < pageSize || fresh.length === 0) {
      return { count: results.length, results };
    }
  }
};

export const getDatafromApi = async (url) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    },
  };
  try {
    let response = await fetch(url, requestOptions);
    let dataResponse = await response.json();
    if (response.ok) {
      return dataResponse;
    }
  } catch (error) {
    console.error('error', error);
  }
}
